const projects = {
    eyebrow: 'Work',
    title: 'Things I have built',
    description: 'Self-directed projects taken from idea to deployment — product decisions, schema, API and interface all my own.',
    selectedTitle: 'Selected work',
    selectedDescription: 'A couple of projects I built end to end, from data model to deployed interface.',
    viewAll: 'All projects',
};

export default projects;
